import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i2 from 'base-work-experience-details-library';
import { BaseWorkExperienceDetailsLibraryService } from 'base-work-experience-details-library';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { first } from 'rxjs/internal/operators/first';
import * as i11 from '@angular/forms';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import * as i1$1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'primeng/dynamicdialog';
import * as i6 from 'dirty-check-store';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from '@angular/router';
import * as i10 from 'app-services-library';
import * as i12 from '@angular/common';
import * as i13 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i14 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i15 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i16 from 'primeng/divider';
import * as i17 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i18 from 'primeng/button';
import * as i19 from 'primeng/tooltip';
import * as i20 from '@angular/material/icon';
import * as i21 from 'generic-beneficiary-work-experience';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import * as i22 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i23 from 'primeng/table';
import * as i24 from 'primeng/api';
import * as i25 from 'primeng/card';
import * as i26 from 'primeng/chips';
import * as i27 from 'send-back-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import * as i28 from 'notification-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import * as i29 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i30 from 'date-format';
import { DateFormatModule } from 'date-format';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { PrimengLibraryModule } from 'primeng-library';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class ApiWorkExperienceDetailsLibraryService {
    constructor(http) {
        this.http = http;
    }
    getBeneExperienceInformation(visatype, caseType, caseId, synctype, superTaskId, subTaskId) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            return response.data;
        }));
    }
}
ApiWorkExperienceDetailsLibraryService.ɵfac = function ApiWorkExperienceDetailsLibraryService_Factory(t) { return new (t || ApiWorkExperienceDetailsLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
ApiWorkExperienceDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ApiWorkExperienceDetailsLibraryService, factory: ApiWorkExperienceDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiWorkExperienceDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["workExperienceForm"];
const _c1 = function (a0) { return { "layoutCode": a0 }; };
function WorkExperienceDetailsLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "h5", 17);
    i0.ɵɵtext(4, "Enter Beneficiary Experience Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵelementStart(6, "ul");
    i0.ɵɵelementStart(7, "li", 19);
    i0.ɵɵelement(8, "lib-step-status-update-component-library", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 21);
    i0.ɵɵelement(10, "lib-maximize-dialog-library", 22);
    i0.ɵɵelementStart(11, "i", 23);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_3_Template_i_click_11_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.caseType != "I130" ? ctx_r1.inputData.visatype : ctx_r1.inputData.caseType)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c1, ctx_r1.inputData == null ? null : ctx_r1.inputData.layoutCode));
} }
function WorkExperienceDetailsLibraryComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 26);
    i0.ɵɵlistener("updateStatus", function WorkExperienceDetailsLibraryComponent_div_4_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r2.inputData.visatype)("stepDetails", ctx_r2.stepDetails)("isViewMode", ctx_r2.inputData["isViewMode"])("isCaseRequest", ctx_r2.inputData["isCaseRequest"]);
} }
function WorkExperienceDetailsLibraryComponent_p_divider_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 27);
} }
function WorkExperienceDetailsLibraryComponent_lib_last_update_library_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 28);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r4.stepDetails)("primaryData", ctx_r4.inputData);
} }
function WorkExperienceDetailsLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "button", 30);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.sycProfilePitition(); });
    i0.ɵɵelementStart(2, "span", 31);
    i0.ɵɵtext(3, "SYNC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 32);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_8_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.syncMerge(); });
    i0.ɵɵelementStart(5, "span", 33);
    i0.ɵɵtext(6, "MERGE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 34);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_8_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.syncReset(); });
    i0.ɵɵelementStart(8, "span", 35);
    i0.ɵɵtext(9, "RESET");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 36);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_8_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r18); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.onClickEditImmigation(); });
    i0.ɵɵelementStart(11, "mat-icon", 37);
    i0.ɵɵtext(12, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 38);
    i0.ɵɵtext(14, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-generic-beneficiary-work-experience", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("primaryData", ctx_r6.inputData)("isWizard", true)("isTimeLine", true);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_1_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 57);
    i0.ɵɵelementStart(1, "span", 58);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r31 = ctx.$implicit;
    const i_r32 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "workExpDetailsCol+", i_r32, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(col_r31.header);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 54);
    i0.ɵɵelement(1, "th", 55);
    i0.ɵɵtemplate(2, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_1_th_2_Template, 3, 2, "th", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r29 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", columns_r29);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 71);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "VisaDateFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r33 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, rowData_r33["endDate"]));
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 72);
    i0.ɵɵtext(1, "Present");
    i0.ɵɵelementEnd();
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 59);
    i0.ɵɵelement(2, "button", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 61);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 62);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 63);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 64);
    i0.ɵɵtemplate(11, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_span_11_Template, 3, 3, "span", 65);
    i0.ɵɵtemplate(12, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_span_12_Template, 2, 0, "span", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 67);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 68);
    i0.ɵɵelementStart(16, "button", 69);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r41); const rowData_r33 = ctx.$implicit; const ctx_r40 = i0.ɵɵnextContext(3); return ctx_r40.deleteExperienceList(rowData_r33); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 70);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r41); const rowData_r33 = ctx.$implicit; const ctx_r42 = i0.ɵɵnextContext(3); return ctx_r42.handleExperienceSync(rowData_r33); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r33 = ctx.$implicit;
    const expanded_r34 = ctx.expanded;
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", rowData_r33)("icon", expanded_r34 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rowData_r33["designation"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r33["employmentType"] ? rowData_r33["employmentType"]["name"] : rowData_r33["employmentType"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 10, rowData_r33["startDate"]), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", rowData_r33["endDate"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !rowData_r33["endDate"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", rowData_r33["companyName"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r27.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r27.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_4_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 57);
    i0.ɵɵelementStart(1, "span", 58);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r53 = ctx.$implicit;
    const i_r54 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "expColHeader+", i_r54, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", col_r53.header, " ");
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_4_th_1_Template, 3, 2, "th", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r51 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r51);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_5_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 64);
    i0.ɵɵelementStart(1, "span", 58);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r58 = ctx.$implicit;
    const i_r59 = ctx.index;
    const rowData_r55 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "expColText+", i_r59, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r55[col_r58.field], " ");
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_5_td_1_Template, 3, 2, "td", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r56 = ctx.columns;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r56);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 79);
    i0.ɵɵtext(2, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_7_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 89);
    i0.ɵɵelementStart(1, "div", 90);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 91);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 91);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r62 = ctx.$implicit;
    const i_r63 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "clientNameColText+", i_r63, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r62.clientName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, item_r62.startDate), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, item_r62.endDate), " ");
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "h6", 81);
    i0.ɵɵtext(2, "Clients Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 82);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵelementStart(5, "div", 84);
    i0.ɵɵelementStart(6, "h6", 85);
    i0.ɵɵtext(7, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 84);
    i0.ɵɵelementStart(9, "h6", 86);
    i0.ɵɵtext(10, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 84);
    i0.ɵɵelementStart(12, "h6", 87);
    i0.ɵɵtext(13, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_7_div_14_Template, 9, 8, "div", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subexperiencelist_r43 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", subexperiencelist_r43.clients);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵtext(1, " Sub-Duty ");
    i0.ɵɵelementEnd();
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 106);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵelementStart(2, "div", 108);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 109);
    i0.ɵɵelementStart(5, "button", 110);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_div_13_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r73); const subDuty_r70 = ctx.$implicit; const subexperiencelist_r43 = i0.ɵɵnextContext(3).$implicit; const ctx_r71 = i0.ɵɵnextContext(3); return ctx_r71.subDutiesDelete(subDuty_r70, subexperiencelist_r43); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subDuty_r70 = ctx.$implicit;
    const i_r67 = i0.ɵɵnextContext().index;
    const ctx_r69 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "subDutyDesc+", i_r67, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", subDuty_r70.subDutyDescription, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r69.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵelementStart(1, "div", 95);
    i0.ɵɵelementStart(2, "span", 96);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 97);
    i0.ɵɵelementStart(5, "div", 98);
    i0.ɵɵelementStart(6, "div", 99);
    i0.ɵɵtext(7, " Duty ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 100);
    i0.ɵɵelementStart(9, "button", 101);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r77); const item_r66 = ctx.$implicit; const subexperiencelist_r43 = i0.ɵɵnextContext(2).$implicit; const ctx_r75 = i0.ɵɵnextContext(3); return ctx_r75.dutiesDelete(item_r66, subexperiencelist_r43); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 102);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_div_12_Template, 2, 0, "div", 103);
    i0.ɵɵtemplate(13, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_div_13_Template, 6, 3, "div", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r66 = ctx.$implicit;
    const i_r67 = ctx.index;
    const ctx_r65 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r67 + 1);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", ctx_r65.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "dutyTextId+", i_r67, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r66.duty, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r66.subDuties.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r66.subDuties);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "h6", 92);
    i0.ɵɵtext(2, "Duties & Sub-duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 82);
    i0.ɵɵtemplate(4, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_div_4_Template, 14, 6, "div", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subexperiencelist_r43 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", subexperiencelist_r43.jobDuties);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r80 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r80.skillName);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "h6", 111);
    i0.ɵɵtext(2, "Added Tools & Technology");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵelementStart(4, "p-chips", 112);
    i0.ɵɵlistener("ngModelChange", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_Template_p_chips_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r83); const subexperiencelist_r43 = i0.ɵɵnextContext().$implicit; return subexperiencelist_r43.tools = $event; });
    i0.ɵɵtemplate(5, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_ng_template_5_Template, 2, 1, "ng-template", 113);
    i0.ɵɵlistener("onRemove", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_Template_ng_template_onRemove_5_listener() { i0.ɵɵrestoreView(_r83); const ctx_r84 = i0.ɵɵnextContext(4); return ctx_r84.handleToolsDelete(ctx_r84.item); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subexperiencelist_r43 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", subexperiencelist_r43.tools);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 58);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext();
    const i_r88 = ctx_r93.index;
    const item_r87 = ctx_r93.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "fileNameId+", i_r88, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r87.fileName, " ");
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 124);
    i0.ɵɵelement(1, "i", 125);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 130);
} if (rf & 2) {
    const item_r87 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r94 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r94.disabledControls)("stepDetails", ctx_r94.stepDetails)("primaryData", ctx_r94.primaryData)("item", item_r87);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵelementStart(1, "button", 127);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r98); const item_r87 = i0.ɵɵnextContext().$implicit; const ctx_r96 = i0.ɵɵnextContext(5); return ctx_r96.openDoc(item_r87); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 128);
    i0.ɵɵelementStart(3, "button", 129);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r98); const item_r87 = i0.ɵɵnextContext().$implicit; const subexperiencelist_r43 = i0.ɵɵnextContext(2).$implicit; const ctx_r99 = i0.ɵɵnextContext(3); return ctx_r99.deleteDocuments(subexperiencelist_r43, item_r87); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r87 = i0.ɵɵnextContext().$implicit;
    const ctx_r91 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r87.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.userType !== "Beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r91.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_10_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 132);
} if (rf & 2) {
    const item_r87 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r103 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r103.disabledControls)("stepDetails", ctx_r103.stepDetails)("destination", ctx_r103.notifyDestinationUser)("primaryData", ctx_r103.primaryData)("item", item_r87);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 118);
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_10_notification_component_library_1_Template, 1, 5, "notification-component-library", 131);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r92.userType !== "Beneficiary");
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 89);
    i0.ɵɵelementStart(1, "div", 115);
    i0.ɵɵelementStart(2, "span", 96);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 58);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 115);
    i0.ɵɵtemplate(7, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_span_7_Template, 2, 2, "span", 120);
    i0.ɵɵtemplate(8, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_span_8_Template, 3, 0, "span", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_9_Template, 4, 3, "div", 122);
    i0.ɵɵtemplate(10, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_div_10_Template, 2, 1, "div", 123);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r87 = ctx.$implicit;
    const i_r88 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r88 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "fileCatNameId+", i_r88, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r87 == null ? null : item_r87.fileCategory.code) === "OTHER" && item_r87.isPresent ? item_r87.fileCategoryOtherName : item_r87 == null ? null : item_r87.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r87.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r87.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r87 == null ? null : item_r87.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r87 == null ? null : item_r87.isPresent));
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "h6", 114);
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 82);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵelementStart(5, "div", 115);
    i0.ɵɵelementStart(6, "h6", 116);
    i0.ɵɵtext(7, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 115);
    i0.ɵɵelementStart(9, "h6", 117);
    i0.ɵɵtext(10, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 118);
    i0.ɵɵelementStart(12, "h6", 119);
    i0.ɵɵtext(13, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_div_14_Template, 11, 7, "div", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subexperiencelist_r43 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", subexperiencelist_r43.documents);
} }
const _c2 = function (a0) { return [a0]; };
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 73);
    i0.ɵɵelementStart(2, "div", 74);
    i0.ɵɵelementStart(3, "p-table", 75);
    i0.ɵɵtemplate(4, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_4_Template, 2, 1, "ng-template", 51);
    i0.ɵɵtemplate(5, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_5_Template, 2, 1, "ng-template", 52);
    i0.ɵɵtemplate(6, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_ng_template_6_Template, 3, 0, "ng-template", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_7_Template, 15, 1, "div", 77);
    i0.ɵɵtemplate(8, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_8_Template, 5, 1, "div", 77);
    i0.ɵɵtemplate(9, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_9_Template, 6, 1, "div", 77);
    i0.ɵɵtemplate(10, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_div_10_Template, 15, 1, "div", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subexperiencelist_r43 = ctx.$implicit;
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("columns", ctx_r28.experienceSubCols)("value", i0.ɵɵpureFunction1(6, _c2, subexperiencelist_r43));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (subexperiencelist_r43 == null ? null : subexperiencelist_r43.clients == null ? null : subexperiencelist_r43.clients.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (subexperiencelist_r43 == null ? null : subexperiencelist_r43.jobDuties == null ? null : subexperiencelist_r43.jobDuties.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (subexperiencelist_r43 == null ? null : subexperiencelist_r43.tools == null ? null : subexperiencelist_r43.tools.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (subexperiencelist_r43 == null ? null : subexperiencelist_r43.documents == null ? null : subexperiencelist_r43.documents.length) > 0);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 50);
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_1_Template, 3, 1, "ng-template", 51);
    i0.ɵɵtemplate(2, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_2_Template, 18, 12, "ng-template", 52);
    i0.ɵɵtemplate(3, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_ng_template_3_Template, 11, 8, "ng-template", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("columns", ctx_r22.experienceCols)("value", ctx_r22.gcWorkExperienceDetailsResponseList);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 133);
    i0.ɵɵtext(1, "Work experience details need to be filled under Beneficiary profile before syncing work experience data here.");
    i0.ɵɵelementEnd();
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "h6", 134);
    i0.ɵɵtext(2, "Specialized Knowledge");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 48);
    i0.ɵɵelement(4, "lib-editor-library", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("events", ctx_r25.onSaveEmitSubject.asObservable())("primaryData", ctx_r25.inputData);
} }
function WorkExperienceDetailsLibraryComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵelementStart(3, "h6", 42);
    i0.ɵɵtext(4, "Work Experience Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WorkExperienceDetailsLibraryComponent_ng_container_10_p_table_5_Template, 4, 2, "p-table", 43);
    i0.ɵɵtemplate(6, WorkExperienceDetailsLibraryComponent_ng_container_10_ng_template_6_Template, 2, 0, "ng-template", null, 44, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(8, WorkExperienceDetailsLibraryComponent_ng_container_10_div_8_Template, 5, 2, "div", 45);
    i0.ɵɵelementStart(9, "div", 46);
    i0.ɵɵelementStart(10, "h6", 47);
    i0.ɵɵtext(11, "Experience Summary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 48);
    i0.ɵɵelement(13, "lib-editor-library", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r23 = i0.ɵɵreference(7);
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r7.gcWorkExperienceDetailsResponseList.length > 0)("ngIfElse", _r23);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.showSpecializedKnowledgeSection);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("events", ctx_r7.onSaveEmitSubject.asObservable())("primaryData", ctx_r7.primaryData);
} }
function WorkExperienceDetailsLibraryComponent_ng_template_11_Template(rf, ctx) { }
function WorkExperienceDetailsLibraryComponent_div_13_p_divider_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function WorkExperienceDetailsLibraryComponent_div_13_p_divider_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function WorkExperienceDetailsLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_div_13_p_divider_1_Template, 1, 0, "p-divider", 9);
    i0.ɵɵelement(2, "lib-custom-questionnaire", 136);
    i0.ɵɵtemplate(3, WorkExperienceDetailsLibraryComponent_div_13_p_divider_3_Template, 1, 0, "p-divider", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.isSimplifyH1b ? false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("stepId", ctx_r10.primaryData.stepId)("taskId", ctx_r10.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", ctx_r10.stepDetails.stepName)("isSection", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.isSimplifyH1b ? false : true);
} }
const _c3 = function (a0) { return { hideView: a0 }; };
function WorkExperienceDetailsLibraryComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 140);
    i0.ɵɵelementStart(1, "button", 141);
    i0.ɵɵelementStart(2, "span", 142);
    i0.ɵɵtext(3, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, (ctx_r108.inputData["isViewMode"] || ctx_r108.inputData["isCaseRequest"]) && ctx_r108.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r0.invalid || ctx_r108.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", _r0.invalid || ctx_r108.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 140);
    i0.ɵɵelementStart(1, "button", 143);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_14_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(2); return ctx_r111.saveCloseEditWorkExperince(); });
    i0.ɵɵelementStart(2, "span", 144);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, (ctx_r109.inputData["isViewMode"] || ctx_r109.inputData["isCaseRequest"]) && ctx_r109.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r109.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r109.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r114 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 140);
    i0.ɵɵelementStart(1, "button", 145);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_14_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r114); const ctx_r113 = i0.ɵɵnextContext(2); return ctx_r113.handleCancel(); });
    i0.ɵɵelementStart(2, "span", 146);
    i0.ɵɵtext(3, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, (ctx_r110.inputData["isViewMode"] || ctx_r110.inputData["isCaseRequest"]) && ctx_r110.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r110.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_div_14_div_1_Template, 4, 5, "div", 137);
    i0.ɵɵtemplate(2, WorkExperienceDetailsLibraryComponent_div_14_div_2_Template, 4, 5, "div", 137);
    i0.ɵɵtemplate(3, WorkExperienceDetailsLibraryComponent_div_14_div_3_Template, 4, 4, "div", 137);
    i0.ɵɵelement(4, "div", 118);
    i0.ɵɵelementStart(5, "div", 138);
    i0.ɵɵelement(6, "lib-step-status-update-component-library", 139);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isWorkExperienceView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.isWorkExperienceView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isWorkExperienceView);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3, (ctx_r11.inputData["isViewMode"] || ctx_r11.inputData["isCaseRequest"]) && ctx_r11.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r11.inputData.caseType != "I130" ? ctx_r11.inputData.visatype : ctx_r11.inputData.caseType)("stepDetails", ctx_r11.stepDetails)("type", ctx_r11.typeOfButton)("isViewMode", ctx_r11.inputData["isViewMode"])("isCaseRequest", ctx_r11.inputData["isCaseRequest"])("showPreviousStepBtn", ctx_r11.showPrev)("showNextStepBtn", ctx_r11.showNext);
} }
function WorkExperienceDetailsLibraryComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 150);
    i0.ɵɵelementStart(1, "button", 141);
    i0.ɵɵelementStart(2, "span", 151);
    i0.ɵɵtext(3, "Save & Continue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r115 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, (ctx_r115.inputData["isViewMode"] || ctx_r115.inputData["isCaseRequest"]) && ctx_r115.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r0.invalid || ctx_r115.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", _r0.invalid || ctx_r115.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 152);
    i0.ɵɵelementStart(1, "button", 143);
    i0.ɵɵlistener("click", function WorkExperienceDetailsLibraryComponent_div_15_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(2); return ctx_r117.saveCloseEditWorkExperince(); });
    i0.ɵɵelementStart(2, "span", 153);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, (ctx_r116.inputData["isViewMode"] || ctx_r116.inputData["isCaseRequest"]) && ctx_r116.userType == "Attorney"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r116.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r116.disabledControls);
} }
function WorkExperienceDetailsLibraryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 147);
    i0.ɵɵtemplate(1, WorkExperienceDetailsLibraryComponent_div_15_div_1_Template, 4, 5, "div", 148);
    i0.ɵɵtemplate(2, WorkExperienceDetailsLibraryComponent_div_15_div_2_Template, 4, 5, "div", 149);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isWorkExperienceView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.isWorkExperienceView);
} }
class WorkExperienceDetailsLibraryComponent extends BaseWorkExperienceDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialogService, guard, cacheCountyService, referenceLibraryService, router, appServicesLibraryService) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialogService, guard, cacheCountyService, referenceLibraryService, router, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.dialogService = dialogService;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onSaveEmitSubject = new Subject();
        this.selectedState = 'simple';
        this.onDialogClose = new EventEmitter();
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        super.loadInit();
    }
    onChange($event) {
        this.selectedState = $event.value;
        if (this.selectedState === 'complete') {
            //this.redirectToProfile();
        }
        else if (this.selectedState === 'simple') {
            //this.isEditMode = false;
        }
    }
    ngAfterViewInit() {
        this.workExperienceForm = this.workExperienceForm;
        super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    postBeneWorkExperience() {
        this.onSaveEmitSubject.next();
        super.postFormSubmission();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
WorkExperienceDetailsLibraryComponent.ɵfac = function WorkExperienceDetailsLibraryComponent_Factory(t) { return new (t || WorkExperienceDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.APIWorkExperienceDetails), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.DialogService), i0.ɵɵdirectiveInject(i6.DirtyFormGuard), i0.ɵɵdirectiveInject(i7.CacheCountryListService), i0.ɵɵdirectiveInject(i8.ReferenceLibraryService), i0.ɵɵdirectiveInject(i9.Router), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService)); };
WorkExperienceDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: WorkExperienceDetailsLibraryComponent, selectors: [["work-experience-details-library"]], viewQuery: function WorkExperienceDetailsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workExperienceForm = _t.first);
    } }, inputs: { simplifyH1b: "simplifyH1b", primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 16, vars: 11, consts: [[1, "fluid-container"], [3, "ngSubmit"], ["workExperienceForm", "ngForm"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust-v2"], ["sectionCode", "BEN_WE", 3, "inputDetails", "primaryData", 4, "ngIf"], ["class", "btn-group", 4, "ngIf"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["editImmigation", ""], ["class", "row pt-3", 4, "ngIf"], ["class", "row pt-0", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "w-100", "d-flex"], ["id", "enterExpDetailsLbl", 1, "mb-0", "common-bene-class-for-translation"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", "mt-1", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], ["sectionCode", "BEN_WE", 3, "inputDetails", "primaryData"], [1, "btn-group"], ["pButton", "", "type", "button", "pTooltip", "Sync With Profile", "icon", "pi pi-arrow-right-arrow-left", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["id", "syncBtnId", 1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", "pTooltip", "Merge Both Profile & Petition Data", "icon", "pi pi-sync\n          ", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["id", "mergeBtnId", 1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", "pTooltip", "Reset Petition Data", "icon", "pi pi-undo", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["id", "resetBtnId", 1, "common-bene-class-for-translation"], ["button", "", "pButton", "", "pTooltip", "Edit", 1, "p-button-outlined", "mr-2", "btnData", 3, "disabled", "click"], [1, "mr-1", "icn"], ["id", "editBtnId", 1, "common-bene-class-for-translation"], [3, "primaryData", "isWizard", "isTimeLine"], [1, "row", "pt-3"], [1, "profile-title", "w-100"], ["id", "workExpDetailsLbl", 1, "common-bene-class-for-translation"], ["class", "profile-table pa-table im-card-no-border-table im-card-table-noborder-spacing table", "styleClass", "p-datatable-gridlines", "dataKey", "id", 3, "columns", "value", 4, "ngIf", "ngIfElse"], ["noWorkExp", ""], ["class", "row col-md-12 pl-0 pr-0 profile-title pt-3", 4, "ngIf"], [1, "row", "col-md-12", "pl-0", "pr-0", "profile-title", "pt-3"], ["id", "expSummaryLbl", 1, "common-bene-class-for-translation"], [1, "col-md-12", "pl-0", "pr-0"], ["infoName", "Petition Letter List", "infoType", "WORKEXSUM", 3, "events", "primaryData"], ["styleClass", "p-datatable-gridlines", "dataKey", "id", 1, "profile-table", "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "columns", "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], [1, "text-uppercase"], [1, "tableHeader", 2, "width", "3rem"], ["class", "tableHeader", 4, "ngFor", "ngForOf"], [1, "tableHeader"], [1, "common-bene-class-for-translation", 3, "id"], [1, "expandIcon", "eduTable"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["id", "designationColId", 1, "eduTable", "common-bene-class-for-translation"], ["id", "empTypeColId", 1, "eduTable", "common-bene-class-for-translation"], [1, "eduTable", "common-bene-class-for-translation"], [1, "eduTable"], ["class", "common-bene-class-for-translation", 4, "ngIf"], ["class", "common-bene-class-for-translation", "id", "presentTillDtId", 4, "ngIf"], ["id", "companyNameId", 1, "eduTable", "common-bene-class-for-translation"], [1, "table-btn", "eduTable"], ["type", "button", "pButton", "", "icon", "pi pi-trash", "pTooltip", "Delete Experience", 1, "p-button-text", "p-button-rounded", "btnTrash", 3, "disabled", "click"], ["type", "button", "pButton", "", "icon", "pi pi-refresh", "pTooltip", "Sync", 1, "p-button-text", "p-button-rounded", "refreshIcon", 3, "disabled", "click"], [1, "common-bene-class-for-translation"], ["id", "presentTillDtId", 1, "common-bene-class-for-translation"], ["colspan", "7"], [1, "p-p-3", "sub-task-type"], ["dataKey", "subTaskId", 1, "sub-task-table", "profile-table", 3, "columns", "value"], ["pTemplate", "emptymessage"], ["class", "courseList pt-4", 4, "ngIf"], ["class", "eduTable", 4, "ngFor", "ngForOf"], ["id", "noDataMsg", "colspan", "6", 1, "eduTable", "common-bene-class-for-translation"], [1, "courseList", "pt-4"], ["id", "clientDetailsLblId", 1, "common-bene-class-for-translation"], [1, "courses-card"], [1, "row", "document-header"], [1, "col-md-4"], ["id", "clientDetailNameLbl", 1, "common-bene-class-for-translation"], ["id", "clientStartDateLbl", 1, "common-bene-class-for-translation"], ["id", "clientEndDateLbl", 1, "common-bene-class-for-translation"], ["class", "row courses courses-title d-flex align-items-center", 4, "ngFor", "ngForOf"], [1, "row", "courses", "courses-title", "d-flex", "align-items-center"], [1, "col-md-4", "common-bene-class-for-translation", 3, "id"], [1, "col-md-4", "common-bene-class-for-translation"], ["id", "dutiesAndSubDutiesLbl", 1, "common-bene-class-for-translation"], ["class", "row courses courses-title mt-2 mb-2", 4, "ngFor", "ngForOf"], [1, "row", "courses", "courses-title", "mt-2", "mb-2"], [1, "col-md-1", "mt-3", "text-center"], [1, "duty-list"], [1, "col-md-11", "pl-0"], [1, "row", "col-md-12", "duty-title", "d-flex", "align-items-center"], ["id", "dutyLbl", 1, "col-md-11", "pr-0", "pl-0", "common-bene-class-for-translation", 2, "font-weight", "600"], [1, "col-md-1", "pr-0", "pl-0"], ["pButton", "", "pTooltip", "Delete Duty", "type", "button", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], [1, "row", "col-md-12", "duty-txt", "common-bene-class-for-translation", 3, "id"], ["class", "row col-md-12 duty-title common-bene-class-for-translation", "id", "subDutyTextId", "style", "font-size: 13px;font-weight: 600;", 4, "ngIf"], ["class", "row col-md-12 p-0", 4, "ngFor", "ngForOf"], ["id", "subDutyTextId", 1, "row", "col-md-12", "duty-title", "common-bene-class-for-translation", 2, "font-size", "13px", "font-weight", "600"], [1, "row", "col-md-12", "p-0"], [1, "row", "col-md-12", "duty-txt"], [1, "col-md-11", "p-0", "common-bene-class-for-translation", 2, "font-size", "14px", 3, "id"], [1, "col-md-1", "p-0"], ["pButton", "", "type", "button", "pTooltip", "Delete Sub Duty", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], ["id", "addedToolsAndTechLbl", 1, "common-bene-class-for-translation"], ["separator", ",", "disabled", "false", "allowDuplicate", "false", 1, "greenCard-chip", 3, "ngModel", "ngModelChange"], ["pTemplate", "item", "class", "common-bene-class-for-translation", "id", "skillName", 3, "onRemove"], ["id", "docListLbl", 1, "common-bene-class-for-translation"], [1, "col-md-5"], ["id", "docTypeLbl", 1, "common-bene-class-for-translation"], ["id", "docNameLbl", 1, "common-bene-class-for-translation"], [1, "col-md-2"], ["id", "actionLbl", 1, "common-bene-class-for-translation"], ["class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], ["class", "redColor d-flex align-items-center common-bene-class-for-translation", "id", "docMissingLbl", 4, "ngIf"], ["class", "col-md-2 pull-right d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2", 4, "ngIf"], ["id", "docMissingLbl", 1, "redColor", "d-flex", "align-items-center", "common-bene-class-for-translation"], [1, "pi", "pi-exclamation-triangle", "pr-2"], [1, "col-md-2", "pull-right", "d-flex", "align-items-center"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item", 4, "ngIf"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item"], ["id", "beforeSyncText", 1, "pb-3", "common-bene-class-for-translation"], ["id", "splKnowledgeLbl", 1, "common-bene-class-for-translation"], ["infoName", "Petition Letter List", "infoType", "SPECKNWLDG", 3, "events", "primaryData"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"], ["class", "col-md-2", 3, "ngClass", 4, "ngIf"], [1, "col-md-6", "completeStep", 3, "ngClass"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "isViewMode", "isCaseRequest", "showPreviousStepBtn", "showNextStepBtn"], [1, "col-md-2", 3, "ngClass"], ["pButton", "", "type", "submit", 3, "ngClass", "disabled"], ["id", "workExpSaveBtn", 1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", 3, "ngClass", "disabled", "click"], ["id", "workExpCloseBtn", 1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", 1, "p-button-secondary", "cancel-btn", "button-width-icon-left", "d-flex", "alogn-items-center", 3, "disabled", "click"], ["id", "workExpCancelBtn", 1, "common-bene-class-for-translation"], [1, "row", "pt-0"], ["class", "col-md-12 customSave alignRight pt-3", 3, "ngClass", 4, "ngIf"], ["class", "col-md-12 customSave alignRight", 3, "ngClass", 4, "ngIf"], [1, "col-md-12", "customSave", "alignRight", "pt-3", 3, "ngClass"], ["id", "saveAndContinueBtn", 1, "common-bene-class-for-translation"], [1, "col-md-12", "customSave", "alignRight", 3, "ngClass"], ["id", "workExpLibCloseBtn", 1, "common-bene-class-for-translation"]], template: function WorkExperienceDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1, 2);
        i0.ɵɵlistener("ngSubmit", function WorkExperienceDetailsLibraryComponent_Template_form_ngSubmit_1_listener() { return ctx.postBeneWorkExperience(); });
        i0.ɵɵtemplate(3, WorkExperienceDetailsLibraryComponent_div_3_Template, 12, 7, "div", 3);
        i0.ɵɵtemplate(4, WorkExperienceDetailsLibraryComponent_div_4_Template, 3, 4, "div", 4);
        i0.ɵɵtemplate(5, WorkExperienceDetailsLibraryComponent_p_divider_5_Template, 1, 0, "p-divider", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, WorkExperienceDetailsLibraryComponent_lib_last_update_library_7_Template, 1, 2, "lib-last-update-library", 7);
        i0.ɵɵtemplate(8, WorkExperienceDetailsLibraryComponent_div_8_Template, 15, 4, "div", 8);
        i0.ɵɵtemplate(9, WorkExperienceDetailsLibraryComponent_div_9_Template, 2, 3, "div", 9);
        i0.ɵɵtemplate(10, WorkExperienceDetailsLibraryComponent_ng_container_10_Template, 14, 5, "ng-container", 10);
        i0.ɵɵtemplate(11, WorkExperienceDetailsLibraryComponent_ng_template_11_Template, 0, 0, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, WorkExperienceDetailsLibraryComponent_div_13_Template, 4, 8, "div", 9);
        i0.ɵɵtemplate(14, WorkExperienceDetailsLibraryComponent_div_14_Template, 7, 13, "div", 12);
        i0.ɵɵtemplate(15, WorkExperienceDetailsLibraryComponent_div_15_Template, 3, 2, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r8 = i0.ɵɵreference(12);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWorkExperienceView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWorkExperienceView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWorkExperienceView)("ngIfElse", _r8);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isWorkExperienceView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
    } }, directives: [i11.ɵangular_packages_forms_forms_ba, i11.NgControlStatusGroup, i11.NgForm, i12.NgIf, i13.StepStatusUpdateComponentLibraryComponent, i14.MaximizeDialogLibraryComponent, i15.AssigningTaskLibraryComponent, i16.Divider, i17.LastUpdateLibraryComponent, i18.ButtonDirective, i19.Tooltip, i20.MatIcon, i21.GenericBeneficiaryWorkExperienceComponent, i22.EditorLibraryComponent, i23.Table, i24.PrimeTemplate, i12.NgForOf, i23.RowToggler, i25.Card, i26.Chips, i11.NgControlStatus, i11.NgModel, i27.SendBackComponentLibraryComponent, i28.NotificationComponentLibrary, i29.CustomQuestionnaireComponent, i12.NgClass], pipes: [i30.VisaDateFormatPipe], styles: [".courses-title[_ngcontent-%COMP%]{padding:0;border-bottom:1px solid #979797}.courses-title[_ngcontent-%COMP%]:last-child{border-bottom:none;padding:0}.redColor[_ngcontent-%COMP%]{color:#e80b18!important}.icons-arrow[_ngcontent-%COMP%]{cursor:pointer}.profile-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 600 20px/28px Source Sans Pro;color:#0a7bb8}.btn-group[_ngcontent-%COMP%]{justify-content:right!important}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:2px}.btnData[_ngcontent-%COMP%]{padding:10px!important}.syncBtn[_ngcontent-%COMP%]{width:100px!important;font-size:14px!important;font-weight:700!important}.pi-arrow-right-arrow-left[_ngcontent-%COMP%]:before{padding-left:10px!important}.mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.profile-table[_ngcontent-%COMP%]   .imagilityFlagIcon[_ngcontent-%COMP%]{padding:10px 5px}.profile-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:18px 15px 6px;color:#4a4a4a}.duty-title[_ngcontent-%COMP%]{background-color:#eff6ff;margin-bottom:0;color:grey}.duty-title[_ngcontent-%COMP%], .duty-txt[_ngcontent-%COMP%]{padding:10px;border:1px solid #b0b0b0;font:normal normal normal 19px/27px Source Sans Pro}.duty-txt[_ngcontent-%COMP%]{color:#626262}.editExperience[_ngcontent-%COMP%]{background:#f8f8f8;padding:20px 0}.expandIcon[_ngcontent-%COMP%]{display:inline-flex;border-right:none!important}.expandIcon[_ngcontent-%COMP%]   .flag-text[_ngcontent-%COMP%]{color:#2c2c2c;font-size:14px;padding:5px 10px}.pa-table[_ngcontent-%COMP%]{border-bottom:2px solid #dee2e6}.pa-table[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;font-style:normal;font-variant:normal;font-weight:700}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#4a4a4a;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;padding:15px 15px 0!important}.pa-table[_ngcontent-%COMP%]   .courseList[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 700 18px/25px Source Sans Pro;color:#626262}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4f5c;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   .duty-list[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.tableHeader[_ngcontent-%COMP%]{background:#efefef 0 0 no-repeat padding-box!important}.eduTable[_ngcontent-%COMP%], .tableHeader[_ngcontent-%COMP%]{border:none!important}.pi-check[_ngcontent-%COMP%]:before{content:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2223.5%22 height%3D%2217.66%22 viewBox%3D%220 0 23.5 17.66%22%3E  %3Cg id%3D%22Group_306%22 data-name%3D%22Group 306%22 transform%3D%22translate(-835.271 -201.546)%22%3E    %3Cg id%3D%22Group_301%22 data-name%3D%22Group 301%22%3E      %3Cg id%3D%22Group_300%22 data-name%3D%22Group 300%22%3E        %3Cg id%3D%22Group_299%22 data-name%3D%22Group 299%22%3E          %3Cg id%3D%22Group_298%22 data-name%3D%22Group 298%22%3E            %3Cpath id%3D%22Path_208%22 data-name%3D%22Path 208%22 d%3D%22M839.048%2C211.877a.75.75%2C0%2C0%2C1-.746-.684c-.027-.307-.04-.566-.04-.816a8.83%2C8.83%2C0%2C0%2C1%2C14.949-6.368.75.75%2C0%2C1%2C1-1.039%2C1.082%2C7.33%2C7.33%2C0%2C0%2C0-12.409%2C5.286c0%2C.2.011.422.034.684a.75.75%2C0%2C0%2C1-.681.813Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_209%22 data-name%3D%22Path 209%22 d%3D%22M838.8%2C212.45a.749.749%2C0%2C0%2C1-.6-.294l-2.776-3.622a.75.75%2C0%2C0%2C1%2C1.191-.912l2.321%2C3.028%2C3.038-2.315a.75.75%2C0%2C0%2C1%2C.909%2C1.193l-3.633%2C2.768A.747.747%2C0%2C0%2C1%2C838.8%2C212.45Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E    %3Cg id%3D%22Group_305%22 data-name%3D%22Group 305%22%3E      %3Cg id%3D%22Group_304%22 data-name%3D%22Group 304%22%3E        %3Cg id%3D%22Group_303%22 data-name%3D%22Group 303%22%3E          %3Cg id%3D%22Group_302%22 data-name%3D%22Group 302%22%3E            %3Cpath id%3D%22Path_210%22 data-name%3D%22Path 210%22 d%3D%22M846.948%2C219.206a8.787%2C8.787%2C0%2C0%2C1-6.116-2.463.75.75%2C0%2C1%2C1%2C1.039-1.082%2C7.33%2C7.33%2C0%2C0%2C0%2C12.409-5.286c0-.2-.011-.422-.034-.684a.75.75%2C0%2C0%2C1%2C1.494-.132c.027.307.04.567.04.816A8.842%2C8.842%2C0%2C0%2C1%2C846.948%2C219.206Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_211%22 data-name%3D%22Path 211%22 d%3D%22M858.022%2C213.424a.749.749%2C0%2C0%2C1-.6-.294l-2.32-3.028-3.038%2C2.315a.75.75%2C0%2C0%2C1-.909-1.193l3.633-2.768a.75.75%2C0%2C0%2C1%2C1.05.14l2.775%2C3.622a.75.75%2C0%2C0%2C1-.595%2C1.206Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\")!important}.updateExperience[_ngcontent-%COMP%]{position:absolute;display:flex;padding-left:360px;padding-bottom:20px}.hideView[_ngcontent-%COMP%]{visibility:hidden}.customSave[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}"], data: { animation: [
            trigger('rowExpansionTrigger', [
                state('void', style({
                    transform: 'translateX(-10%)',
                    opacity: 0
                })),
                state('active', style({
                    transform: 'translateX(0)',
                    opacity: 1
                })),
                transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WorkExperienceDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'work-experience-details-library',
                templateUrl: 'work-experience-details-library.component.html',
                styleUrls: ['work-experience-details-library.component.scss'],
                animations: [
                    trigger('rowExpansionTrigger', [
                        state('void', style({
                            transform: 'translateX(-10%)',
                            opacity: 0
                        })),
                        state('active', style({
                            transform: 'translateX(0)',
                            opacity: 1
                        })),
                        transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
                    ])
                ],
                viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.APIWorkExperienceDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DialogService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i9.Router }, { type: i10.AppServicesLibraryService }]; }, { simplifyH1b: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], workExperienceForm: [{
            type: ViewChild,
            args: ['workExperienceForm', { static: true }]
        }] }); })();

class WorkExperienceDetailsLibraryModule {
}
WorkExperienceDetailsLibraryModule.ɵfac = function WorkExperienceDetailsLibraryModule_Factory(t) { return new (t || WorkExperienceDetailsLibraryModule)(); };
WorkExperienceDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: WorkExperienceDetailsLibraryModule });
WorkExperienceDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseWorkExperienceDetailsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            DeleteDialogLibraryModule,
            SendBackComponentLibraryModule,
            NotificationComponentLibraryModule,
            EditorLibraryModule,
            DateFormatModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            CustomQuestionnaireModule,
            MatButtonToggleModule,
            GenericBeneficiaryWorkExperienceModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(WorkExperienceDetailsLibraryModule, { declarations: [WorkExperienceDetailsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        DeleteDialogLibraryModule,
        SendBackComponentLibraryModule,
        NotificationComponentLibraryModule,
        EditorLibraryModule,
        DateFormatModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        CustomQuestionnaireModule,
        MatButtonToggleModule,
        GenericBeneficiaryWorkExperienceModule], exports: [WorkExperienceDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WorkExperienceDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [WorkExperienceDetailsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    SendBackComponentLibraryModule,
                    NotificationComponentLibraryModule,
                    EditorLibraryModule,
                    DateFormatModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    CustomQuestionnaireModule,
                    MatButtonToggleModule,
                    GenericBeneficiaryWorkExperienceModule
                ],
                providers: [BaseWorkExperienceDetailsLibraryService],
                exports: [WorkExperienceDetailsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of work-experience-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiWorkExperienceDetailsLibraryService, WorkExperienceDetailsLibraryComponent, WorkExperienceDetailsLibraryModule };
//# sourceMappingURL=work-experience-details-library.js.map
